import { api } from '@goaltree/backend/convex/_generated/api'
import { useMutation, useQuery } from 'convex/react'
import { Ban } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { SettingsGroup, SettingsRow, rowId } from '@/components/settings/primitives'
import { UserAvatar } from '@/components/user-avatar'

/** People you blocked (from a story's ⋯ menu), each with Unblock. */
export function BlockedSettings() {
  const { t } = useTranslation()
  const blocked = useQuery(api.blocks.list)
  const unblock = useMutation(api.blocks.unblock)
  return (
    <SettingsGroup label={t('stories.blocks.title')}>
      {!blocked?.length ? (
        <SettingsRow
          id={rowId('stories.blocks.title')}
          icon={<Ban className="h-4 w-4" />}
          label={t('stories.blocks.empty')}
          description={t('stories.blocks.desc')}
        />
      ) : (
        blocked.map((b) => (
          <SettingsRow
            key={b.userId}
            icon={
              <UserAvatar image={b.image} name={b.name} size={32} className="size-8 rounded-lg" />
            }
            label={b.name}
          >
            <button
              type="button"
              onClick={() =>
                void unblock({ userId: b.userId })
                  .then(() => toast.success(t('stories.blocks.unblocked', { name: b.name })))
                  .catch(() => toast.error(t('stories.blocks.failed')))
              }
              className="cursor-pointer rounded-md border px-3 py-1 text-sm font-semibold hover:bg-muted"
            >
              {t('stories.blocks.unblock')}
            </button>
          </SettingsRow>
        ))
      )}
    </SettingsGroup>
  )
}
